import { AT } from '../../../actions/actionTypes';
import {
  State,
  UpdateSettigns,
  Payload,
  ValidationFetchPL,
  ValidationPL,
  ValidationErrorPL,
} from './model';
import { StateDefault, RegisterDeviceDefault } from './defaults';
import * as CallStatus from '../../../utils/callStatus';
import { validateKeys } from './utils';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

const defaultState: State = StateDefault;

export default function (state = defaultState, action: any) {
  switch (action.type) {
    case AT.DIALOG_REGISTER_SETTINGS_UPDATED: {
      Logger.info(
        [AT.DIALOG_REGISTER_SETTINGS_UPDATED, action],
        LogArea.Redux
      );
      const { keys }: UpdateSettigns = action.payload;
      return { ...state, keys };
    }

    case AT.DIALOG_REGISTER_FETCH: {
      Logger.info([AT.DIALOG_REGISTER_FETCH, action], LogArea.Redux);
      return CallStatus.fetch(state);
    }

    case AT.DIALOG_REGISTER_SUCCESS: {
      Logger.info([AT.DIALOG_REGISTER_SUCCESS, action], LogArea.Redux);
      const { validatedDevices }: Payload = action.payload;
      const keys = validateKeys(state.keys, validatedDevices);
      return { ...CallStatus.success(state), keys };
    }

    case AT.DIALOG_REGISTER_ERROR: {
      Logger.info([AT.DIALOG_REGISTER_ERROR, action], LogArea.Redux);
      return CallStatus.error(state, '');
    }

    case AT.DIALOG_REGISTER_VALIDATE_FETCH: {
      Logger.info(
        [AT.DIALOG_REGISTER_VALIDATE_FETCH, action],
        LogArea.Redux
      );
      const { validatedDevice, code }: ValidationFetchPL = action.payload;
      const rd = RegisterDeviceDefault(validatedDevice, code);
      const editingDevice = CallStatus.fetch(rd);
      return { ...state, editingDevice };
    }

    case AT.DIALOG_REGISTER_VALIDATE_SUCCESS: {
      Logger.info(
        [AT.DIALOG_REGISTER_VALIDATE_SUCCESS, action],
        LogArea.Redux
      );
      const { validatedDevice, code }: ValidationPL = action.payload;
      const rd = RegisterDeviceDefault(validatedDevice, code);
      rd.errorMsg = validatedDevice.message;

      const keys = rd.errorMsg ? state.keys : [...state.keys, rd];
      const editingDevice = rd.errorMsg ? rd : undefined;

      return { ...state, editingDevice, keys };
    }

    case AT.DIALOG_REGISTER_VALIDATE_ERROR: {
      Logger.info(
        [AT.DIALOG_REGISTER_VALIDATE_ERROR, action],
        LogArea.Redux
      );
      const { validatedDevice, code }: ValidationErrorPL = action.payload;
      const rd = RegisterDeviceDefault(validatedDevice, code);
      const editingDevice = CallStatus.error(rd, validatedDevice.message);
      return { ...state, editingDevice };
    }

    default: {
      return state;
    }
  }
}
